import {IconButton, IconButtonProps} from "@mui/material";
import {FC} from "react";

const BaseIconButton: FC<IconButtonProps> = (props) => {
  return <IconButton {...props} size="large">{props.children}</IconButton>;
};

export default BaseIconButton;
